import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { downgradeToAJSService } from 'ib-web-commons/utils';
import { IbDisruptedSeatsRefundModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-refund-model';
import { IbDisruptedSeatsService } from '../../ib-disrupted-seats/services/ib-disrupted-seats.service';
import { IbDisruptedSeatsComponent } from '../../ib-disrupted-seats/ib-disrupted-seats.component';
import { IbDisruptedSeatsModel } from '../../../../core/models/disrupted-seats/ib-disrupted-seats-model';
import { IbDisruptedSeatsRefundModalComponent } from '../../ib-disrupted-seats/ib-disrupted-seats-refund-modal/ib-disrupted-seats-refund-modal.component';


@Injectable({
    providedIn: 'root'
})
export class IbNewModalAncillariesService {

    mockModel: IbDisruptedSeatsModel = {
        metadata: {
            errors: [
                {
                    code: 'code',
                    description: 'description'
                }
            ]
        },
        data: {
            options: [
                'ACCEPT',
                'CHANGE',
                'REFUND'
            ],
            info: {
                segments: [
                    {
                        origin: {
                            code: 'MAD',
                            description: 'Madrid'
                        },
                        destination: {
                            code: 'BIO',
                            description: 'Bilbao'
                        },
                        passengers: [
                            {
                                emd: {
                                    amount: 100.0,
                                    currency: 'EUR'
                                },
                                seats: [
                                    {
                                        status: 'ORIGINAL',
                                        value: {
                                            row: '5',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'E',
                                            'L',
                                            'W'
                                        ],
                                        type: 'EMERGENCY_EXIT'
                                    },
                                    {
                                        status: 'REASSIGNED',
                                        value: {
                                            row: '7',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'L',
                                            'O'
                                        ],
                                        type: 'XL'
                                    }
                                ]
                            },
                            {
                                emd: {
                                    amount: 100.0,
                                    currency: 'EUR'
                                },
                                seats: [
                                    {
                                        status: 'ORIGINAL',
                                        value: {
                                            row: '5',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'E',
                                            'L',
                                            'W'
                                        ],
                                        type: 'EMERGENCY_EXIT'
                                    },
                                    {
                                        status: 'REASSIGNED',
                                        value: {
                                            row: '7',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'L',
                                            'O'
                                        ],
                                        type: 'XL'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        origin: {
                            code: 'BIO',
                            description: 'Bilbao'
                        },
                        destination: {
                            code: 'MAD',
                            description: 'Madrid'
                        },
                        passengers: [
                            {
                                emd: {
                                    amount: 100.0,
                                    currency: 'EUR'
                                },
                                seats: [
                                    {
                                        status: 'ORIGINAL',
                                        value: {
                                            row: '5',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'E',
                                            'L',
                                            'W'
                                        ],
                                        type: 'EMERGENCY_EXIT'
                                    },
                                    {
                                        status: 'REASSIGNED',
                                        value: {
                                            row: '7',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'L',
                                            'O'
                                        ],
                                        type: 'XL'
                                    }
                                ]
                            },
                            {
                                emd: {
                                    amount: 100.0,
                                    currency: 'EUR'
                                },
                                seats: [
                                    {
                                        status: 'ORIGINAL',
                                        value: {
                                            row: '5',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'E',
                                            'L',
                                            'W'
                                        ],
                                        type: 'EMERGENCY_EXIT'
                                    },
                                    {
                                        status: 'REASSIGNED',
                                        value: {
                                            row: '7',
                                            column: 'B'
                                        },
                                        padisFeatures: [
                                            'L',
                                            'O'
                                        ],
                                        type: 'XL'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    };


    constructor (
        private modalService: NgbModal,
        private disruptedSeatsService: IbDisruptedSeatsService
    ) { }

    openDisruptedSeatsModal (flowId: string, creationDate: string): void {

        this.disruptedSeatsService.getDisruptedSeatsData(flowId, creationDate).subscribe({
            next: (response: IbDisruptedSeatsModel) => {
                const modalRef = this.modalService.open(
                    IbDisruptedSeatsComponent,
                    {
                        windowClass: 'ib-modals-full fade'
                    }
                );
                modalRef.componentInstance.model = response;
                modalRef.componentInstance.flowId = flowId;
                modalRef.componentInstance.creationDate = creationDate;

                modalRef.result.then((result) => {
                });
            },
            error: (error: IbDisruptedSeatsModel) => {}
        });

    }
}

downgradeToAJSService('IbNewModalAncillariesService', IbNewModalAncillariesService, 'ib-web-ancillaries-module', ['NgbModal, IbDisruptedSeatsService']);